var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","border":"1px solid #dedede","height":"600px"}},[_vm._v(" Document Content ")])}
var staticRenderFns = []

export { render, staticRenderFns }